

// // src/redux/reducers/leaveReducer.js
// import {
//   GET_LEAVE_TYPES_REQUEST,
//   GET_LEAVE_TYPES_SUCCESS,
//   GET_LEAVE_TYPES_FAIL,
//   APPLY_LEAVE_REQUEST,
//   APPLY_LEAVE_SUCCESS,
//   APPLY_LEAVE_FAIL,
// } from "../actions/leaveActions";

// const initialState = {
//   loading: false,
//   leaveTypes: [],
//   applyLeaveStatus: null,
//   error: null,
// };

// const leaveReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case GET_LEAVE_TYPES_REQUEST:
//     case APPLY_LEAVE_REQUEST:
//       return { ...state, loading: true, error: null };

//     case GET_LEAVE_TYPES_SUCCESS:
//       return { ...state, loading: false, leaveTypes: action.payload };

//     case APPLY_LEAVE_SUCCESS:
//       return { ...state, loading: false, applyLeaveStatus: "success" };

//     case GET_LEAVE_TYPES_FAIL:
//     case APPLY_LEAVE_FAIL:
//       return { ...state, loading: false, error: action.payload };

//     default:
//       return state;
//   }
// };

// export default leaveReducer;


// import {
//   GET_LEAVE_TYPES_REQUEST,
//   GET_LEAVE_TYPES_SUCCESS,
//   GET_LEAVE_TYPES_FAIL,
//   APPLY_LEAVE_REQUEST,
//   APPLY_LEAVE_SUCCESS,
//   APPLY_LEAVE_FAIL,
//   GET_LEAVE_STATUS_REQUEST,
//   GET_LEAVE_STATUS_SUCCESS,
//   GET_LEAVE_STATUS_FAIL,
// } from "../actions/leaveActions";

// const initialState = {
//   loading: false,
//   leaveTypes: [],
//   applyLeaveStatus: null,
//   leaveStatusData: [],
//   error: null,
// };

// const leaveReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case GET_LEAVE_TYPES_REQUEST:
//     case APPLY_LEAVE_REQUEST:
//     case GET_LEAVE_STATUS_REQUEST:
//       return { ...state, loading: true, error: null };

//     case GET_LEAVE_TYPES_SUCCESS:
//       return { ...state, loading: false, leaveTypes: action.payload };

//     case APPLY_LEAVE_SUCCESS:
//       return { ...state, loading: false, applyLeaveStatus: "success" };

//     case GET_LEAVE_STATUS_SUCCESS:
//       return { ...state, loading: false, leaveStatusData: action.payload };

//     case GET_LEAVE_TYPES_FAIL:
//     case APPLY_LEAVE_FAIL:
//     case GET_LEAVE_STATUS_FAIL:
//       return { ...state, loading: false, error: action.payload };

//     default:
//       return state;
//   }
// };

// export default leaveReducer;


import {
  GET_LEAVE_TYPES_REQUEST,
  GET_LEAVE_TYPES_SUCCESS,
  GET_LEAVE_TYPES_FAIL,
  APPLY_LEAVE_REQUEST,
  APPLY_LEAVE_SUCCESS,
  APPLY_LEAVE_FAIL,
  GET_LEAVE_STATUS_REQUEST,
  GET_LEAVE_STATUS_SUCCESS,
  GET_LEAVE_STATUS_FAIL,
  GET_REMAINING_LEAVES_REQUEST,
  GET_REMAINING_LEAVES_SUCCESS,
  GET_REMAINING_LEAVES_FAIL,
} from "../actions/leaveActions";

const initialState = {
  loading: false,
  leaveTypes: [],
  applyLeaveStatus: null,
  leaveStatusData: [],
  remainingLeaves: [],
  error: null,
};

const leaveReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LEAVE_TYPES_REQUEST:
    case APPLY_LEAVE_REQUEST:
    case GET_LEAVE_STATUS_REQUEST:
    case GET_REMAINING_LEAVES_REQUEST:
      return { ...state, loading: true, error: null };

    case GET_LEAVE_TYPES_SUCCESS:
      return { ...state, loading: false, leaveTypes: action.payload };

    case APPLY_LEAVE_SUCCESS:
      return { ...state, loading: false, applyLeaveStatus: "success" };

    case GET_LEAVE_STATUS_SUCCESS:
      return { ...state, loading: false, leaveStatusData: action.payload };

    case GET_REMAINING_LEAVES_SUCCESS:
      return { ...state, loading: false, remainingLeaves: action.payload };

    case GET_LEAVE_TYPES_FAIL:
    case APPLY_LEAVE_FAIL:
    case GET_LEAVE_STATUS_FAIL:
    case GET_REMAINING_LEAVES_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default leaveReducer;
